import React from 'react';
import * as yup from 'yup';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { useDispatch } from 'react-redux';
import * as employeeApi from '../../../lib/api/employee';
import RecordLicenseForm from '../../../components/employeemng/resume/RecordLicenseForm';
import { listRecordLicense } from '../../../modules/empModule/empResume';

const RecordLicenseFormContainer = ({ employee }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    attrVal1: '',
    attrVal2: '',
    attrVal3: '',
    attrVal4: '',
    attrVal5: '',
    file: null,
  };

  const validationSchema = yup.object({
    attrVal1: yup.string('').required('자격증을 입력하세요'),
    attrVal2: yup.string().required('발급처를 입력하세요'),
    attrVal3: yup.date().required('발급일을 입력하세요'),
    attrVal4: yup.string().required('자격증 번호를 입력하세요'),
    attrVal5: yup.string().nullable(),
    file: yup.mixed().nullable('파일을 선택하세요'),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values)
     
      setSubmitting(false);
    },
  });

 
  const onSave = async(values)=>{
    let attrVal3 = values.attrVal3
    ? dayjs(values.attrVal3).format('YYYY-MM-DD')
    : dayjs(new Date()).format('YYYY-MM-DD');

    let formData = new FormData();
    formData.append('fileDt', values.file);
    formData.append('fileTyp', 'RECORD_LICENSE');
    formData.append('usrUuid', employee.usrUuid);
    formData.append('infoTyp', "RECORD_LICENSE");
    formData.append('attrVal1', values.attrVal1);
    formData.append('attrVal2', values.attrVal2);
    formData.append('attrVal3', attrVal3);
    formData.append('attrVal4', values.attrVal4);
    formData.append('attrVal5', values.attrVal5);

    try {
      const response = await employeeApi.addResumeLicenseByEmp(formData);
      if (response.data) {
        formik.resetForm();
        dispatch(
          listRecordLicense({
            id: employee.usrUuid,
            infoTyp: 'RECORD_LICENSE',
          }),
        );
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  
  }

  const onSaveNotFile = async(values)=>{
    let dataToSubmit = {
      usrUuid: employee.usrUuid,
      infoTyp:'RECORD_LICENSE',
      attrVal1: values.attrVal1,
      attrVal2: values.attrVal2,
      attrVal3: values.attrVal3
      ? dayjs(values.attrVal3).format('YYYY-MM-DD')
      : dayjs(new Date()).format('YYYY-MM-DD'),
      attrVal4: values.attrVal4,
      attrVal5: values.attrVal5,
    };

    //console.log(JSON.stringify(dataToSubmit),'dataToSubmit');

    try {
      const response = await employeeApi.addResumeByEmp(dataToSubmit);
      if (response.data) {
        dispatch(
          listRecordLicense({
            id: employee.usrUuid,
            infoTyp: 'RECORD_LICENSE',
          }),
        );
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  }

  return <RecordLicenseForm formik={formik}/>;
};

export default RecordLicenseFormContainer;
